import { WebMercatorViewport } from '@deck.gl/core/typed';
import { getBboxObjectDeckGl } from 'app/helpers/bboxObjects';
import { useAppDispatch } from 'app/store/store';
import { setBbox } from 'app/utils/mapStateSlice';
import { useCallback } from 'react';

export const
  useUpdateBbox = () => {
  const dispatch = useAppDispatch();

  const updateBbox = useCallback((viewport: WebMercatorViewport) => {
    const bounds = viewport.getBounds();

    if (bounds && bounds.every((e) => typeof e === 'number' && !Number.isNaN(e))) {
      const bboxObject = getBboxObjectDeckGl(bounds, 3);
      dispatch(setBbox(bboxObject));
    }
  }, []);
  return updateBbox;
};
